import { IRenderSceneExtension } from '../model';

export const isAggregationRenderScene = (
  renderScene?: IRenderSceneExtension
) => {
  return !!renderScene?.aggregation?.fieldKey.length;
};

export const isAggregationByFieldKey = (
  key: string,
  renderScene?: IRenderSceneExtension
) => {
  if (!renderScene?.aggregation) {
    return false;
  }
  return renderScene.aggregation.fieldKey.includes(key);
};
